export const getFieldErrorId = (name: string) => `${name}-error`;

export const mergeAriaIds = (...ids: (string | undefined)[]) => ids.filter(Boolean).join(' ') || undefined;
